"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Section = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _index = require("../../provider/ThemeProvider/index");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * A generic Text component
 *
 **/
var Section = function Section(_ref) {
  var _cn;

  var children = _ref.children,
      _ref$globalThemeVaria = _ref.globalThemeVariant,
      globalThemeVariant = _ref$globalThemeVaria === void 0 ? 'pc' : _ref$globalThemeVaria,
      globalThemeSubVariant = _ref.globalThemeSubVariant,
      className = _ref.className,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      _ref$bold = _ref.bold,
      bold = _ref$bold === void 0 ? false : _ref$bold,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
    className: (0, _classnames.default)(_styleModule.default[globalThemeVariant], (_cn = {}, (0, _defineProperty2.default)(_cn, className || "", className), (0, _defineProperty2.default)(_cn, _styleModule.default.bold, bold), (0, _defineProperty2.default)(_cn, _styleModule.default[globalThemeSubVariant], globalThemeSubVariant), (0, _defineProperty2.default)(_cn, _styleModule.default.noMargin, noMargin), _cn)),
    style: {
      textAlign: align
    },
    children: children
  });
};

exports.Section = Section;

var _default = (0, _index.withThemeVariant)( /*#__PURE__*/_react.default.memo(Section));

exports.default = _default;